export interface PaymentCreditCard {
  id?: string;
  cardToken: string;
  cardAccount?: string;
  cardType?: string;
  cardholderName?: string;
  cardNickname?: string;
  cardExpirationDate?: Date;
  lastTransactionDate?: Date;
  isPrimary?: boolean;

  // UI related
  expMonth?: string;
  expYear?: string;
  isSelected?: boolean;
  expired?: boolean;
  cardTypeIconFilename?: string;
}

/*
  The "Card Type ID" (the "number") that is used for making actual payment.
    And the "string" will be from the "Payment Credit Card" entity.
 */
export const CreditCardTypeIds = {
  visa: '1',
  mc: '2',
  ae: '3',
  discover: '4',
};

export const CreditCardTypeIconFilenames = {
  visa: 'visa.svg',
  mc: 'mastercard.svg',
  amex: 'amex.svg',
  disc: 'disc.svg',
  jcb: 'jcb.svg',
  default: 'default.svg',
};


export enum PaymentTypes {
  Cash = '1',
  CreditCard = '2',
  AccountCredit = '3',
  Check = '4',
  GiftCertificate = '5',
  Reallocated = '6',
  TransafeCreditCard = '7',

}
